import React from 'react';
import STC from '../../../../../../STCLibrary/STCFactory/STCFactory';
import { format } from 'date-fns';
import './ViewLeaderTourDetails.css'


export default function ViewLeaderTourDetails({tourDetails}){

    return(
        <div className='leader-tour-details-container'>
            <STC.Row>
                <STC.Col>Booking ID</STC.Col>
                <STC.Col>{tourDetails.bookingId}</STC.Col>
            </STC.Row>
            <STC.Row>
                <STC.Col>School Name</STC.Col>
                <STC.Col>{tourDetails.schoolName}</STC.Col>
            </STC.Row>
            <STC.Row>
                <STC.Col>Destination</STC.Col>
                <STC.Col>{tourDetails.destinations[0]}</STC.Col>
            </STC.Row>
            <STC.Row>
                <STC.Col>Date of Travel</STC.Col>
                <STC.Col>{format(new Date(tourDetails.dateOfTravel), 'dd/LLL/yyyy')}</STC.Col>
            </STC.Row>
            <STC.Row>
                <STC.Col>Date of Return</STC.Col>
                <STC.Col>{format(new Date(tourDetails.dateOfReturn), 'dd/LLL/yyyy')}</STC.Col>
            </STC.Row>
            <hr/>
            <strong>Please note that the travel dates may be subject to change.</strong>
            <hr/>

            {tourDetails.displayDeposits.map((deposit) => {
                if(deposit.shown){
                    return(
                        <STC.Row className={'leader-tour-details-deposit'} key={deposit.id}>
                            <STC.Col sm={8}>{deposit.note} due {format(new Date(deposit.collectionDate), 'dd/LLL/yyyy')}</STC.Col>
                            <STC.Col>{(tourDetails.currency === 'GBP' ? '£': '€')}{deposit.amount}</STC.Col>
                        </STC.Row>
                    )
                }
                
            })}

            <STC.Row>
                <STC.Col sm={8}><strong>Total Tour Price</strong></STC.Col>
                <STC.Col><strong>{(tourDetails.currency === 'GBP' ? '£': '€') + tourDetails.passengerPrice}</strong></STC.Col>
            </STC.Row>
        </div>
    )
}